<div class="label" [class]="alignHorizontal">
  <div layout layout-align-items-center>
    <ng-container
      *ngTemplateOutlet="variant === 'default' ? defaultVariantIcon : otherVariantsIcon"
    />
    @if (variant !== 'rounded') {
      <span>{{ text || ('app.common.add_new' | translate) }}</span>
    }
  </div>
</div>

<ng-template #defaultVariantIcon>
  <rt-icon shape="square" name="add" size="small" />
</ng-template>

<ng-template #otherVariantsIcon>
  <rt-icon name="add" size="small-x" />
</ng-template>
